import type { TranslationTree } from '../../types';

export const common: TranslationTree = {
  common: {
    brand: 'ToolLife',
    loading: 'Loading…',
    close: 'Close',
    clearSelection: 'Clear selection',
    required: 'required',
    retry: 'Retry',
    confirm: 'Confirm',
    delete: 'Delete',
    remove: 'Remove',
    removeItem: 'Remove {{item}}',
    breadcrumb: 'Breadcrumb',
    back: 'Back',
    search: 'Search',
    notProvided: 'Not provided',
    loadingShort: 'Loading…',
    cancel: 'Cancel',
    chooseTheme: 'Choose a theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    reference: 'Reference',
    logoAlt: 'Louis Bélet logo',
  },
  form: {
    validation: {
      requiredTooltip: 'This field is required.',
      requiredMultiTooltip: 'At least one field marked with an orange * must be filled in.',
      requiredMultiAtLeastOne: 'At least one field must be completed.',
      checkboxAtLeastOne: 'Please select at least one option.',
    },
    numberInput: {
      increase: 'Increase value',
      decrease: 'Decrease value',
    },
    select: {
      options: 'Select an option',
    },
  },
};
